export default "__VITE_ASSET__DEMEWiaK__"